class HomeReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    if (this.slides.length <= 1) return;

    this.current = 0;
    this.prevButton = this.querySelector('[data-carousel-prev]');
    this.nextButton = this.querySelector('[data-carousel-next]');
    this.track = this.querySelector('[data-carousel-track]');

    this.prevButton?.addEventListener('click', () => this.go(-1));
    this.nextButton?.addEventListener('click', () => this.go(1));

    const autoplaySeconds = parseInt(this.dataset.autoplay, 10);
    if (autoplaySeconds > 0) {
      this.autoplayInterval = window.setInterval(() => this.go(1), autoplaySeconds * 1000);
      this.addEventListener('mouseenter', () => window.clearInterval(this.autoplayInterval));
      this.addEventListener('mouseleave', () => {
        this.autoplayInterval = window.setInterval(() => this.go(1), autoplaySeconds * 1000);
      });
    }

    this.update();
  }

  disconnectedCallback() {
    if (this.autoplayInterval) window.clearInterval(this.autoplayInterval);
  }

  go(direction) {
    this.current += direction;
    if (this.current < 0) this.current = this.slides.length - 1;
    if (this.current >= this.slides.length) this.current = 0;
    this.update();
  }

  update() {
    if (!this.track) return;
    this.track.style.transform = `translate3d(-${this.current * 100}%, 0, 0)`;
    this.slides.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index === this.current ? 'false' : 'true');
    });
  }
}

if (!customElements.get('home-reviews-carousel')) {
  customElements.define('home-reviews-carousel', HomeReviewsCarousel);
}
